module.exports = __webpack_public_path__ + "img/bank.c478c1a2.svg";